import axios from 'axios'
import router from '../router'
// import {Notify} from 'quasar';
// import ErrorDispose from './errorCode'

let ROOT = ''
if (process.env.NODE_ENV === 'development') {
  // 开发环境下的代理地址，解决本地跨域跨域，配置在config目录下的index.js dev.proxyTable中
  ROOT = '/api/'
} else {
  // 生产环境下的地址
  ROOT = process.env.VUE_APP_API_URL + '/server/v1/'
}

// axios 请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// axios 响应拦截器
axios.interceptors.response.use(function (response) {
  if (response.request.responseType === 'blob') {
    if (!response.data) return response
    let data = response.data
    let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
    let url = window.URL.createObjectURL(blob)
    let aLink = document.createElement('a')
    let fileName = response.headers['content-disposition']
    aLink.style.display = 'none'
    aLink.href = url
    aLink.setAttribute('download', decodeURIComponent(fileName.split('=')[1].replace(/"/g, '')))
    document.body.appendChild(aLink)
    aLink.click()
    document.body.removeChild(aLink) // 下载完成移除元素
    window.URL.revokeObjectURL(url) // 释放掉blob对象
  }
  if (response.headers.code) {
    localStorage.verificationCode = response.headers.code
  }
  if (response.status === 401) {
    if (router.history.current.path !== '/login') {
      let path = router.history.current.path
      let reg = new RegExp('/', 'g')
      setTimeout(function () {
        router.push('/login?page=' + path.replace(reg, '~'))
      }, 1000)
    }
  }
  // 对响应数据做点什么
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

const request = {
  Post: function (url, data, params, config) {
    return axios({
      url: ROOT + '' + url,
      method: 'post',
      data: data || {},
      params: params || {},
      timeout: 60000,
      responseType: url.indexOf('export') > -1 ? 'blob' : (config ? config.responseType || 'arraybuffer' : 'json'),
      headers: {
        'token': window.localStorage.token || ''
      }
    })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        console.log('error:', error.response.data.msg)
        // error.message === 'Network Error' || (error.response && error.response.status === 401)
        if (error.response.data.msg === '登录失效！') {
          window.localStorage.removeItem('token')
          if (router.history.current.path !== '/login') {
            let path = router.history.current.path
            let reg = new RegExp('/', 'g')
            router.replace('/login?page=' + path.replace(reg, '~') + '&&key=1')
            // Notify.create('登录过期，请重新登录')
          }
        } else {
          // Notify.create('发生未知错误，请联系管理员')
        }
        // return error
      })
  },
  ELGet: function (url, data, params, config) {
    return axios({
      url: url,
      method: 'get',
      data: data || {},
      params: params || {},
      timeout: 60000,
      responseType: url.indexOf('export') > -1 ? 'blob' : (config ? config.responseType || 'arraybuffer' : 'json'),
      headers: {
        'token': window.localStorage.token || ''
      }
    })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.message === 'Network Error' || (error.response && error.response.status === 401)) {
          if (router.history.current.path !== '/login') {
            let path = router.history.current.path
            let reg = new RegExp('/', 'g')
            setTimeout(function () {
              router.push('/login?page=' + path.replace(reg, '~'))
            }, 1000)
          }
        } else {
          // Notification({
          //   type: 'error',
          //   title: ErrorDispose(error).title,
          //   duration: 0,
          //   message: ErrorDispose(error).message
          // })
        }
        return error
      })
  }
}

export default request
